import React from 'react';
import PropTypes from 'prop-types';

import DataTable from '@components/DataTable/DataTable'

const sortBykey = (key, dir) => (a,b) => {
	if(a[key] < b[key])
		return -1;
	else if(a[key] > b[key])
		return 1;
	else
		return 0;
}

export default class LocalDataTable extends React.Component {

	static propTypes = {
		data: PropTypes.array,
	};

	constructor(props) {
		super(props)
		this.state = {
			// TODO: get defaults from props
			sortDir: 'asc',
			sortBy: 'status',
			filterQuery: {},
		}
	}

	onChangeFilter = (filterQuery) => this.setState({ filterQuery });
	onChangeSort = (sortBy, sortDir) => this.setState({ sortBy, sortDir });

	filterData(data) {
		const { filters } = this.props;
		const { filterQuery } = this.state;		

		for(let filter of filters) {

			console.log(filter);
			
			const filterValue = filterQuery[filter.name];

			
			if(filterValue == null || filterValue === filter.nullValue) 
				continue;

			// determine filter func
			const filterHandler = filter.filterHandler
				? filter.filterHandler
				: (data, filterValue, filter) => data.filter(item => item[filter.name] === filterValue);

			// apply filter
			data = filterHandler(data, filterValue, filter, filterQuery);

			// break the loop if filtered data is empty (else apply the next filter)
			if(!data.length) break;
		}

		return data;
	}

	sortData(data) {
		const { sortBy, sortDir } = this.state;
		const column = this.props.columns.find(col => col.sortKey === sortBy);

		return column && column.sortHandler
			? data.sort((a, b) => column.sortHandler(sortDir, a, b))
			: data.sort();
	}

	processData() {
		const { data } = this.props;

		if(!data) return [];
		
		const filteredData = this.filterData(data.slice());

		this.sortData(filteredData);

		return filteredData;
	}

	render() {
				// data={this.state.data}
		return (
			<DataTable 
				{...this.props} 
				onChangeSort={this.onChangeSort}
				onChangeFilter={this.onChangeFilter}
				sortDir={this.state.sortDir}
				sortBy={this.state.sortBy}
				data={this.processData()}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LocalDataTable/LocalDataTable.jsx